// @flow

import { connect } from 'react-redux';
import WebConversationOverModel from './WebConversationOverModel';

const mapStateToProps = ({
  scribeConversation: { speakers, status, scribe, inTwilioCalls },
}) => ({
  scribe: !!scribe,
  speakers,
  status,
  inTwilioCalls,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WebConversationOverModel);
